import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { sponsorshipTiers } from './data';

const SponsorshipTiers = ({ onSelectTier }) => (
  <section className="sponsorship-tiers">
    <div className="container">
      <h2 className="section-title">Sponsorship Packages</h2>
      <p className="section-subtitle">Choose the level that&apos;s right for your business</p>

      <div className="tiers-grid">
        {sponsorshipTiers.map((tier) => {
          const IconComponent = tier.icon;
          return (
            <Card
              key={tier.id}
              className={`tier-card ${tier.featured ? 'featured' : ''}`}
              style={{ '--tier-color': tier.color }}
            >
              <CardHeader>
                <div className="tier-icon" style={{ backgroundColor: tier.color }}>
                  <IconComponent size={32} color="#000" />
                </div>
                <CardTitle className="tier-name">{tier.name}</CardTitle>
                <div className="tier-price">{tier.price}</div>
                {tier.featured && <div className="featured-badge">Most Popular</div>}
              </CardHeader>
              <CardContent>
                {tier.benefits.map((group) => (
                  <div key={`${tier.name}-${group.category}`} className="benefit-group">
                    <h4 className="benefit-category">{group.category}</h4>
                    <ul className="benefit-list">
                      {group.items.map((item) => (
                        <li key={item}>
                          <Check size={16} className="check-icon" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
                <Button className="tier-btn" onClick={() => onSelectTier(tier.name)}>
                  Select This Package
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);

export default SponsorshipTiers;
